(function () {
  if (window.__erSliderInit) return;
  window.__erSliderInit = true;

  function initSlider(slider) {
    var track = slider.querySelector('.er-slider__track');
    if (!track) return;

    var slides = track.querySelectorAll('.er-slider__slide');
    var dots = slider.querySelectorAll('[data-er-dot]');
    var mobileOnly = slider.hasAttribute('data-er-slider-mobile');
    var noAutoplay = slider.hasAttribute('data-er-slider-no-autoplay');
    var mq = window.matchMedia('(max-width: 900px)');
    var interval = null;
    var total = slides.length;

    if (total === 0) return;

    function isActive() {
      return !mobileOnly || mq.matches;
    }

    function getCurrentIndex() {
      var trackRect = track.getBoundingClientRect();
      var center = trackRect.left + trackRect.width / 2;
      var closest = 0;
      var minDist = Infinity;

      slides.forEach(function (slide, index) {
        var rect = slide.getBoundingClientRect();
        var slideCenter = rect.left + rect.width / 2;
        var dist = Math.abs(slideCenter - center);
        if (dist < minDist) {
          minDist = dist;
          closest = index;
        }
      });

      return closest;
    }

    function updateDots(index) {
      dots.forEach(function (dot, dotIndex) {
        dot.classList.toggle('is-active', dotIndex === index);
      });
    }

    function goTo(index, smooth) {
      if (!isActive()) return;
      var slide = slides[index];
      if (!slide) return;

      track.scrollTo({
        left: slide.offsetLeft,
        behavior: smooth === false ? 'auto' : 'smooth'
      });
      updateDots(index);
    }

    function startAutoplay() {
      clearInterval(interval);
      if (noAutoplay || !isActive() || total <= 1) return;

      interval = setInterval(function () {
        goTo((getCurrentIndex() + 1) % total);
      }, 5000);
    }

    function setup() {
      clearInterval(interval);

      if (isActive()) {
        track.style.transform = '';
        updateDots(getCurrentIndex());
        startAutoplay();
      } else {
        track.scrollLeft = 0;
        track.style.transform = '';
        updateDots(0);
      }
    }

    track.addEventListener(
      'scroll',
      function () {
        if (!isActive()) return;
        window.clearTimeout(track._erScrollTimer);
        track._erScrollTimer = window.setTimeout(function () {
          updateDots(getCurrentIndex());
        }, 80);
      },
      { passive: true }
    );

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.dataset.erDot, 10));
        startAutoplay();
      });
    });

    if (!noAutoplay) {
      slider.addEventListener(
        'touchstart',
        function () {
          clearInterval(interval);
        },
        { passive: true }
      );

      slider.addEventListener(
        'touchend',
        function () {
          startAutoplay();
        },
        { passive: true }
      );
    }

    mq.addEventListener('change', setup);
    setup();
  }

  document.querySelectorAll('[data-er-slider]').forEach(initSlider);
})();
